import React, { useState, useEffect } from "react";
import { Plus, Edit, Trash } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";

const Chapter = () => {
  const navigate = useNavigate();
  const [chapters, setChapters] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChapterId, setSelectedChapterId] = useState(null);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 20;
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchChapter();
    } else {
      navigate("/");
    }
  }, [navigate, offset]);

  const fetchChapter = async () => {
    try {
      const response = await apiService.postData("admin/chapter-list", {
        limit,
        offset,
      });
      if (response?.data?.rows) {
        setChapters(response.data.rows);
        setTotalCount(response.data.count || 0);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
    }
  };

  const handleEdit = (chapterId) => navigate(`/edit-chapter/${chapterId}`);

  const handleDelete = async () => {
    if (selectedChapterId) {
      try {
        await apiService.deleteData(
          `admin/delete-chapter/${selectedChapterId}`
        );
        setChapters((prev) =>
          prev.filter((ch) => ch.chapter_id !== selectedChapterId)
        );
        setIsModalOpen(false);
      } catch (error) {
        console.error("Error deleting chapter:", error);
      }
    }
  };

  const openModal = (chapterId) => {
    setSelectedChapterId(chapterId);
    setIsModalOpen(true);
  };

  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;
  const renderPagination = () => {
    const pageButtons = [];
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) {
        pageButtons.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - halfRange);
      let endPage = Math.min(totalPages, currentPage + halfRange);

      if (startPage > 1) pageButtons.push(1);
      if (startPage > 2) pageButtons.push("...");

      for (let i = startPage; i <= endPage; i++) {
        pageButtons.push(i);
      }

      if (endPage < totalPages - 1) pageButtons.push("...");
      if (endPage < totalPages) pageButtons.push(totalPages);
    }

    return pageButtons.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setOffset((page - 1) * limit)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="btn mx-1 disabled">
          {page}
        </span>
      )
    );
  };
  const handleCheckboxChange = (chapterId) => {
    setSelectedIds((prev) =>
      prev.includes(chapterId)
        ? prev.filter((id) => id !== chapterId)
        : [...prev, chapterId]
    );
  };
  
  const handleBulkDelete = async () => {
    try {
      await apiService.postData("admin/delete-multiple-chapter", {
        chapter_id: selectedIds,
      });
      setChapters((prev) =>
        prev.filter((c) => !selectedIds.includes(c.chapter_id))
      );
      setSelectedIds([]);
    } catch (error) {
      console.error("Error deleting selected chapter:", error);
    }
  };
  
  return (
    <div className="container">
      <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
      <h4>Chapters</h4>
      <div>
    {selectedIds.length > 0 && (
      <button onClick={handleBulkDelete} className="btn btn-danger me-2">
        Delete Selected <Trash size={16} />
      </button>
    )}

          <button
            onClick={() => navigate("/new-chapter")}
            className="btn btn-primary"
          >
            New Chapter <Plus size={16} />
          </button></div>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                <th>
  <input
    type="checkbox"
    onChange={(e) =>
      setSelectedIds(
        e.target.checked ? chapters.map((c) => c.chapter_id) : []
      )
    }
    checked={chapters.length > 0 && selectedIds.length === chapters.length}
  />
</th>

                  <th>Content name </th>
                  <th>Chapter Name</th>
                  <th>Description</th>
                  <th>Audio</th>
                  {/* <th>Created At</th>
                  <th>Created By</th>
                  <th>Updated At</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {chapters.map((chapter) => (
                  <tr key={chapter.chapter_id}>
                        <td>
  <input
    type="checkbox"
    checked={selectedIds.includes(chapter.chapter_id)}
    onChange={() => handleCheckboxChange(chapter.chapter_id)}
  />
</td>

                    <td>{chapter.ChaptersToContentDetails?.title || "-"}</td>
                    <td>{chapter.title || "-"}</td>
                    <td>
                      {chapter.description?.length > 20 ? (
                        expandedDescriptions[chapter.chapter_id] ? (
                          <>
                            {chapter.description}
                            <button
                              className="btn btn-link p-0"
                              onClick={() =>
                                setExpandedDescriptions((prev) => ({
                                  ...prev,
                                  [chapter.chapter_id]: false,
                                }))
                              }
                            >
                              {" "}
                              Less{" "}
                            </button>
                          </>
                        ) : (
                          <>
                            {chapter.description.substring(0, 20)}...
                            <button
                              className="btn btn-link p-0"
                              onClick={() =>
                                setExpandedDescriptions((prev) => ({
                                  ...prev,
                                  [chapter.chapter_id]: true,
                                }))
                              }
                            >
                              {" "}
                              More{" "}
                            </button>
                          </>
                        )
                      ) : (
                        chapter.description || "-"
                      )}
                    </td>
                    <td>
                      {chapter.audio_file ? (
                        <audio controls className="mt-1">
                          <source
                            src={apiService.getAudioUrl(chapter.audio_file)}
                            type="audio/mp3"
                          />
                          Your browser does not support the audio element.
                        </audio>
                      ) : (
                        "No Audio"
                      )}
                    </td>
                    {/* <td>
                      {chapter.created_at
                        ? new Date(chapter.created_at).toLocaleDateString()
                        : "-"}
                    </td>
                    <td>{chapter.created_by || "-"}</td>
                    <td>
                      {chapter.updated_at
                        ? new Date(chapter.updated_at).toLocaleDateString()
                        : "-"}
                    </td> */}
                    {/* <td className="text-center">
                      <div className="d-flex justify-chapter-center align-items-center gap-2">
                        <button
                          onClick={() => handleEdit(chapter.chapter_id)}
                          className="btn btn-primary btn-sm text-white"
                        >
                          <Edit size={16} />
                        </button>
                        <button
                          onClick={() => openModal(chapter.chapter_id)}
                          className="btn btn-danger btn-sm text-white"
                        >
                          <Trash size={16} />
                        </button>
                      </div>
                    </td> */}
                    <td className="text-center">
  <div className="dropdown">
    <button
      className="btn btn-outline-primary btn-sm dropdown-toggle"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      Actions
    </button>
    <ul className="dropdown-menu">
      <li>
        <button
          className="dropdown-item"
          onClick={() => handleEdit(chapter.chapter_id)}
        >
          <Edit size={14} className="me-2" />
          Edit
        </button>
      </li>
      <li>
        <button
          className="dropdown-item text-danger"
          onClick={() => openModal(chapter.chapter_id)}
        >
          <Trash size={14} className="me-2" />
          Delete
        </button>
      </li>
    </ul>
  </div>
</td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <nav className="d-flex justify-content-center my-3">
        <button
          className="btn btn-outline-primary me-2"
          onClick={() => setOffset(offset - limit)}
          disabled={offset === 0}
        >
          «
        </button>
        {renderPagination()}
        <button
          className="btn btn-outline-primary ms-2"
          onClick={() => setOffset(offset + limit)}
          disabled={offset + limit >= totalCount}
        >
          »
        </button>
      </nav>
      {isModalOpen && (
      <div
      className="modal fade show"
      tabIndex="-1"
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Deletion</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setIsModalOpen(false)}
            ></button>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to delete this chapter?</p>
          </div>
          <div className="modal-footer">
            <button className="btn btn-danger" onClick={handleDelete}>
              Yes
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setIsModalOpen(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
    
      )}
    </div>
  );
};

export default Chapter;
